import { cn } from '@/lib/cn';

/**
 * Freshness banner — color-coded data-freshness strip below the topbar.
 *
 * Pure presentational. The `state` maps 1:1 to the `.freshness-banner`
 * modifier classes (.fresh / .stale / .blocked) and the `.dot` tints with
 * the current color.
 */

export type FreshnessBannerState = 'fresh' | 'stale' | 'blocked';

export interface FreshnessBannerProps {
  state: FreshnessBannerState;
  label: string;
}

export function FreshnessBanner({ state, label }: FreshnessBannerProps) {
  return (
    <div className={cn('freshness-banner', state)} role="status" aria-live="polite">
      <span className="dot" />
      <span>{label}</span>
    </div>
  );
}
